
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faqAb1Lu6f2M_45A0uSPFa3xaTGJh8d3X0R703rewW1NsMM8Meta } from "/codebuild/output/src3348435689/src/src/pages/faq.vue?macro=true";
import { default as menu2IPIRPHMOiPQdn71yN_D56_45b_jlj8pusmyLqmw4zpCwMeta } from "/codebuild/output/src3348435689/src/src/pages/menu.vue?macro=true";
import { default as indexedvQ35ucXpn_IobbnbCD6hHDu1bOSM50li_TZs7xEjwMeta } from "/codebuild/output/src3348435689/src/src/pages/index.vue?macro=true";
import { default as contactGA5AClxfi6VSJwbUCsXqzU_45s_QYw2vY1cCxAQiUxfw0Meta } from "/codebuild/output/src3348435689/src/src/pages/contact.vue?macro=true";
import { default as tutorialUaemJjx9D78LRrYu01Bb6souv6lqNWqc5YxwU60GEvYMeta } from "/codebuild/output/src3348435689/src/src/pages/tutorial.vue?macro=true";
import { default as agreementO3v1sFgg7pV0Fs0c3PjaEn06CcEplLMAW3XuOrSebaUMeta } from "/codebuild/output/src3348435689/src/src/pages/agreement.vue?macro=true";
import { default as about_45passr8cdk4_V_45ZMN4iedSQ5wzxcpIhdQxfYHJW_IxolwfV0Meta } from "/codebuild/output/src3348435689/src/src/pages/about-pass.vue?macro=true";
import { default as indexL_Xmi8Xjtj1N1AUAo8Rb_aPGTci7KFciET9HeHmJm_UMeta } from "/codebuild/output/src3348435689/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93Hy9c43_45z5utsLKXoPwQZGTIBFL_45YTruUEicLOxVWWGQMeta } from "/codebuild/output/src3348435689/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenanceU0d9AfTtOVBlLHefh5C3mrGjyl_45o_UI_456ufm1EVUnO4Meta } from "/codebuild/output/src3348435689/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93zwp0aZ3B_uSWBrYJ1AqhDo5n9rcaJDe0sd9Cu2sPlV8Meta } from "/codebuild/output/src3348435689/src/src/pages/notice/[id].vue?macro=true";
import { default as indexUuo28R_45Tnveiu_45_451QNbrj_TPnyzyHWJ_45LHmMTMtANz0Meta } from "/codebuild/output/src3348435689/src/src/pages/coupon/index.vue?macro=true";
import { default as indexGNUUH_45fzuypbcYPcit89ADwp1Z_45nKMhAzujoyJ_iEVMMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/index.vue?macro=true";
import { default as indexJxQ54MQE5NwNUbBL_45gD9_45TSNiTx7jkZXbyC8tqXDfvYMeta } from "/codebuild/output/src3348435689/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93s7hh4dhxqxiPvHsjLO3TETLkjnL_aWYmQzC4q3sY8hUMeta } from "/codebuild/output/src3348435689/src/src/pages/parking/[id].vue?macro=true";
import { default as index2pVrAAnCNXK0gArPYXaCV8rUrfbPHyG2rn_45xQVFgJ6IMeta } from "/codebuild/output/src3348435689/src/src/pages/history/index.vue?macro=true";
import { default as indexKquOvRCsA_n4BqemcVEfGUjLCqg36fWBwU8q4AGAuJ0Meta } from "/codebuild/output/src3348435689/src/src/pages/monthly/index.vue?macro=true";
import { default as index_J8UvyJ4QhQ1wkx7B3k_YA4y6dBT1AQtnL0wQgVTlNQMeta } from "/codebuild/output/src3348435689/src/src/pages/sign-in/index.vue?macro=true";
import { default as index2xZkGn7DjtaLALg8qyxgHogfgMI81Z_45X_45jj0Vp7QmkQMeta } from "/codebuild/output/src3348435689/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenaviyTe5ZYEaNs53nrr_3e3THwY0z55NagGoGGhlrp7N1SEMeta } from "/codebuild/output/src3348435689/src/src/pages/about-yumenavi.vue?macro=true";
import { default as edit6XojeKZFmPnPU9I1CFI_U7Xxg2tHIwwdPZJPzadZn3sMeta } from "/codebuild/output/src3348435689/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementYCU_fQ7FxM4cEt0f5ehByErRzXXnfnAF8ndIRnfd8tYMeta } from "/codebuild/output/src3348435689/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexJW_45Ubl2GhSatX61zTiVVUcFzooYZ3R4H32SG_45dOP8sgMeta } from "/codebuild/output/src3348435689/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dhhu6E_45PvNNAjEtNg3DSCogPa_ij7svxMKLS_OLjHvHwMeta } from "/codebuild/output/src3348435689/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmYqIvXbYdNaahwAGrJdO1ZBPbnlvL4hvNbTVmvoDa9sYMeta } from "/codebuild/output/src3348435689/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexMxbIHMVV1JgpyQt2laoFLm13WnB8VmMj_45bvr9M9lh7oMeta } from "/codebuild/output/src3348435689/src/src/pages/card/create/index.vue?macro=true";
import { default as index678ProMxzprAyzUjaePRvj_45cbXQxe2ffsIYhZXV3EpQMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmN3887SYA06g_GyU1UTJZfMhdqHJkzaGs81s8AETR8EQMeta } from "/codebuild/output/src3348435689/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmzH31Jq8ICxyOtEkvRh2I0qFvR9Ouqh_45z5uc_45uVTeCSgMeta } from "/codebuild/output/src3348435689/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeDv2ZwxKNvjyZh1EjyAjUD6OIUzXhD6YX8fFggurqcEMMeta } from "/codebuild/output/src3348435689/src/src/pages/membership/complete.vue?macro=true";
import { default as registerqzjuQga6w74nXniSyKumoh1CgNVGiKmNYU_WQvXFW6wMeta } from "/codebuild/output/src3348435689/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93TFwMPotE4UhRF2hnG295G2EoIBVdw95i17PkurqbiScMeta } from "/codebuild/output/src3348435689/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmRpUz88TNwEcidU3NSNhnMS6e140OjpfFQRCyb56175EMeta } from "/codebuild/output/src3348435689/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_933P2_YIli5ONgb5KMP0idDQ6tM88FJGPHuPa2lt900AsMeta } from "/codebuild/output/src3348435689/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexHezW091MOC_45MeuaWW_6MOMzjHsz2rMyjVQefirZ_hJcMeta } from "/codebuild/output/src3348435689/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeL2iwTMnqm_phjp7CO_PdZwHx8mXfphuLfwbDI66w_454AMeta } from "/codebuild/output/src3348435689/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45codeXEZyB9WD3bGIdOcr3yPDI6nAl62sD5pD1zjpV9Z9LRkMeta } from "/codebuild/output/src3348435689/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeMVoxqKgbcIUwIX6o1XrS__CsknP2BmknabpBgjYjf1UMeta } from "/codebuild/output/src3348435689/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerLC7TFlQQTfdbI_s2MbPsUMy2g5QSjSZEeTSEfw0YO1sMeta } from "/codebuild/output/src3348435689/src/src/pages/contact-form/register.vue?macro=true";
import { default as completeUp6ELIXgtlFGWB9_AwS7i6iIuAE4ushS8p8hfDDWxFkMeta } from "/codebuild/output/src3348435689/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as indexFNVLkbuHb_45PeOW_45N3G7l3KC_gYMGGuQhr5afrcAqX9cMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmSFneutBuYOujvSVsgjFq3VKOi1HNSexNd2qdEhTa2TkMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeqnsxt4Pg3SnpdJDFsDV6s8qLEllQWdhMQeMHnGpTd20Meta } from "/codebuild/output/src3348435689/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexUNPiju4_45hWIvJ4ZFNBaCMqZ0Crk7iZ_xyI5gZa00JwAMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93xmJwKbhFf0RdQ47nfX3RlaATPsUBkdPlRipTLHo9opEMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete_BX7OIWIiwDDDg_45oeGLmsdJrA2xsTuI096dpe4qnth0Meta } from "/codebuild/output/src3348435689/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasD6XLp_45UNJSWoL_45u78OGr1Pb3_4547AVH7Qy_T4SWTC7V0Meta } from "/codebuild/output/src3348435689/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplej_gn_p_IF_V9V_45Pbf8R9MU6JX_45t9x5b_45avGZMv_tlBYMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailCp1Kncd0TgIe3f0D_fQsa9Go002k9uqDdPRewz1tBkUMeta } from "/codebuild/output/src3348435689/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirmx92gGaA2Iji3pkgC5JIdHv02paq2DmkHYN_45Zzxs9yZ8Meta } from "/codebuild/output/src3348435689/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent1JXH_3x0EbbvLmEAwn_45WDqBAOafAwCPp_xKkhTs52lAMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmFCaKFJJP1OZusttFxR70drQTJ6rETBdiiOgLhIsUxaUMeta } from "/codebuild/output/src3348435689/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateNU4NN0Mu9SNTi6GUCMGShLsX3h3JJHsF2Rcwm3j3LQ8Meta } from "/codebuild/output/src3348435689/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completeHxW205whLMiM1CncaSdIRcqyVyejqdC0LHwHAZVpn34Meta } from "/codebuild/output/src3348435689/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeCjQz_aO1bUezpgmjSeFZZ60pDmi6JezDenSGXD_45jEoMMeta } from "/codebuild/output/src3348435689/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45passwordXoEWxj91KzHlWPMkr_yuWS_1uxBuBaTV4evLmPCL0lEMeta } from "/codebuild/output/src3348435689/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasJ4aFuJ7HCNk6znFCihGz8_45xudxrmgSxbg5zFxcIQaEYMeta } from "/codebuild/output/src3348435689/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerE6tJDW4xHBRDetc7_6XOnWe8TcMNOFyAzBUxRB7RIPgMeta } from "/codebuild/output/src3348435689/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45coded47Du6kwWUwlGLdL3sjnJ4vGfZbl2MH27RpTq_0Ydd0Meta } from "/codebuild/output/src3348435689/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexPw60uHZMaH4Ha84BpPPJkMdCnzbbD_45SK2wmw6417nQIMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexfo6AJQ_45QAKwgRSadwnlhXeyqnUYFbpohnSX2rwB5lPsMeta } from "/codebuild/output/src3348435689/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexvar3u2hn_456N8lCvBjRm99oxa_9QfVe1A_CbCksEXEvoMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexF8PPVivga3HBijfVc54vRDgrf_cXrtlt2PPVqygU1D8Meta } from "/codebuild/output/src3348435689/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as update2X5NGnlI8SkfC2VoyJGd3AbyciAkfFtUmCAy4tqJSboMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeqsfrGGdA23LBrKxyhvo6l1oo50FkrrM2OHrUofhm3ScMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirmDEQibZGJLpBZCUTR9bFYKal0nIgra9Tb4DdsBEVlnicMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexTljSSlW0dq_45wJ0kWuafagwtoRBeiEYIMkUa1td0TcS8Meta } from "/codebuild/output/src3348435689/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completeG9UukEWaH3EmHv05WXH0uhjJyKWeWFBMrwdVRMwpZSgMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateFU_ErWlWTHvkxA_45P48cdoFXL9FlqMgHKwvJ99p3iseMMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexJagTbZYla940UyxDp5ccg7_29cWjMTSh_45qkiyoiFLwYMeta } from "/codebuild/output/src3348435689/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexbv1hI2qw2B1VeuhGH6JfzWbg_45p2PGo9oJVCvXBx3R48Meta } from "/codebuild/output/src3348435689/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completeCNwNxs_qZ_45STFWj9LXRkB_4WcbIEhLqYJofQRVuARZMMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as indexXhjo8lnHbnSNpJ0r2nX6ralPJc8nIc5yK7Dc5c8xzL8Meta } from "/codebuild/output/src3348435689/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codevoPCCFVVKgU_45x_e8gAQauSgxZtOE6cit_45ISGTyb7wakMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexMFoUpd3RRlbPWAc3l4Mv_45Gl7D6UJM2inLYJ5YdImjlYMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexjvR_45_45fHT4u2AhaZz6zBkHaxHNhc4jVM3TJIQDvDq7m0Meta } from "/codebuild/output/src3348435689/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexhGz_454SdcnADob1YZpMrqCQv5eciZ1lOZs5VJ4nrcj44Meta } from "/codebuild/output/src3348435689/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateJIxG1GQDzUrebxpJ_ww8vDZ_45CmUuolud9bFW0gsZUt8Meta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmfZWRI94r2ha610zNoRcv4keubkLDjo_45RnWvXZlef0yEMeta } from "/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menu2IPIRPHMOiPQdn71yN_D56_45b_jlj8pusmyLqmw4zpCwMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: { ...(indexedvQ35ucXpn_IobbnbCD6hHDu1bOSM50li_TZs7xEjwMeta || {}), ...{"middleware":["search-params"]} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexUuo28R_45Tnveiu_45_451QNbrj_TPnyzyHWJ_45LHmMTMtANz0Meta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(index2pVrAAnCNXK0gArPYXaCV8rUrfbPHyG2rn_45xQVFgJ6IMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index_J8UvyJ4QhQ1wkx7B3k_YA4y6dBT1AQtnL0wQgVTlNQMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: index2xZkGn7DjtaLALg8qyxgHogfgMI81Z_45X_45jj0Vp7QmkQMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexMxbIHMVV1JgpyQt2laoFLm13WnB8VmMj_45bvr9M9lh7oMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmN3887SYA06g_GyU1UTJZfMhdqHJkzaGs81s8AETR8EQMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmzH31Jq8ICxyOtEkvRh2I0qFvR9Ouqh_45z5uc_45uVTeCSgMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeDv2ZwxKNvjyZh1EjyAjUD6OIUzXhD6YX8fFggurqcEMMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerqzjuQga6w74nXniSyKumoh1CgNVGiKmNYU_WQvXFW6wMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmRpUz88TNwEcidU3NSNhnMS6e140OjpfFQRCyb56175EMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeL2iwTMnqm_phjp7CO_PdZwHx8mXfphuLfwbDI66w_454AMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45codeXEZyB9WD3bGIdOcr3yPDI6nAl62sD5pD1zjpV9Z9LRkMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeMVoxqKgbcIUwIX6o1XrS__CsknP2BmknabpBgjYjf1UMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerLC7TFlQQTfdbI_s2MbPsUMy2g5QSjSZEeTSEfw0YO1sMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmSFneutBuYOujvSVsgjFq3VKOi1HNSexNd2qdEhTa2TkMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeqnsxt4Pg3SnpdJDFsDV6s8qLEllQWdhMQeMHnGpTd20Meta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexUNPiju4_45hWIvJ4ZFNBaCMqZ0Crk7iZ_xyI5gZa00JwAMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete_BX7OIWIiwDDDg_45oeGLmsdJrA2xsTuI096dpe4qnth0Meta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplej_gn_p_IF_V9V_45Pbf8R9MU6JX_45t9x5b_45avGZMv_tlBYMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailCp1Kncd0TgIe3f0D_fQsa9Go002k9uqDdPRewz1tBkUMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirmx92gGaA2Iji3pkgC5JIdHv02paq2DmkHYN_45Zzxs9yZ8Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent1JXH_3x0EbbvLmEAwn_45WDqBAOafAwCPp_xKkhTs52lAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmFCaKFJJP1OZusttFxR70drQTJ6rETBdiiOgLhIsUxaUMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completeHxW205whLMiM1CncaSdIRcqyVyejqdC0LHwHAZVpn34Meta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeCjQz_aO1bUezpgmjSeFZZ60pDmi6JezDenSGXD_45jEoMMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45passwordXoEWxj91KzHlWPMkr_yuWS_1uxBuBaTV4evLmPCL0lEMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerE6tJDW4xHBRDetc7_6XOnWe8TcMNOFyAzBUxRB7RIPgMeta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45coded47Du6kwWUwlGLdL3sjnJ4vGfZbl2MH27RpTq_0Ydd0Meta || {},
    component: () => import("/codebuild/output/src3348435689/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3348435689/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]